import { render, staticRenderFns } from "./RegisterForm2BusinessContact.vue?vue&type=template&id=3ba1bb86&scoped=true&"
import script from "./RegisterForm2BusinessContact.vue?vue&type=script&lang=js&"
export * from "./RegisterForm2BusinessContact.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm2BusinessContact.vue?vue&type=style&index=0&id=3ba1bb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1bb86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba1bb86')) {
      api.createRecord('3ba1bb86', component.options)
    } else {
      api.reload('3ba1bb86', component.options)
    }
    module.hot.accept("./RegisterForm2BusinessContact.vue?vue&type=template&id=3ba1bb86&scoped=true&", function () {
      api.rerender('3ba1bb86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterForm2BusinessContact.vue"
export default component.exports